import React, {useMemo } from 'react'
import { useTranslate } from 'react-admin'
import { hasPermissionFunction } from 'src/helper/HasPermission'

export const useReportData = (id, category = 'types') => {
  const translate = useTranslate()

  const data = useMemo(() => ({types: [
      {label:translate('ra.title.payment'), id:0}, 
      {label:translate('ra.entity.supplier'), id:1},
      {label:translate('ra.message.commercial'), id:2},
      {label:translate('ra.entity.sales'), id:3},
      {label:translate('ra.message.payment_allocation'), id:4},
      {label:translate('ra.message.reservation_control'), id:5},
      {label:translate('ra.message.accounting_control'), id:6},
      {label:translate('ra.entity.account-state'), id:7},
      {label:translate('ra.field.smartbookTitle'), id:8},
      {label:translate('ra.message.summarized'), id:9},
      {label:'Metasearch', id:10},
      {label:`${translate('ra.field.reservations')} B2C`, id:11},
    ],
  subtypes: [
      {label:translate('ra.message.detailed_by_item'), id:0}, 
      {label:translate('ra.message.general_detailed'), id:1},
    ],
  datetypes: [
      {label:translate('ra.field.reserve_create_date'), id:0}, 
      {label:translate('ra.field.date_first_service'), id:1},
      {label:translate('ra.field.autocancel_date'), id:2},
      {label:translate('ra.field.payment_due_date'), id:3},
      // {label:translate('ra.field.billing_date'), id:4},
      {label:translate('ra.field.last_update_date'), id:5},
      ...(hasPermissionFunction('reporting', 'internal') 
      ? [{label:translate('ra.field.supplier_due_date'), id:6}]
    : []),
      {label:translate('ra.field.item_create_date'), id:7},
      {label:translate('ra.field.end_date'), id:8},
      {label:translate('ra.field.created_log'), id:9},
      {label:translate('ra.field.invoice_date'), id:10},
    ],
  configurations:[
    {label:translate('ra.message.preconfigured'), id:0}, 
    {label:translate('ra.message.on_demand_date'), id:1},
    {label:translate('ra.message.on_demand_reserve'), id:2},
    {label:translate('ra.message.on_demand_logs'), id:3},
    {label:translate('ra.message.preconfigured_logs'), id:4},
    {label:translate('ra.message.on_demand_account_state'), id:5},
    {label:translate('ra.message.preconfigured_account_state'), id:6},
  ],
  sendingPeriods: [
    {label:translate('ra.message.unique'), id:3},
    {label:translate('ra.message.daily'), id:0}, 
    {label:translate('ra.message.weekly'), id:1},
    {label:translate('ra.message.monthly'), id:2},
  ],
  analisysPeriod: [
    {label:translate('ra.message.yesterday'), id:0}, 
    {label:translate('ra.message.last_days'), id:1},
    {label:translate('ra.message.current_week'), id:2},
    {label:translate('ra.message.last_week'), id:3},
    {label:translate('ra.message.current_month'), id:4},
    {label:translate('ra.message.last_month'), id:5},
    {label:translate('ra.message.current_quarter'), id:6},
    {label:translate('ra.message.previous_quarter'), id:7},
    {label:translate('ra.message.current_year'), id:8},
    {label:translate('ra.message.last_year'), id:9},
    {label:translate('ra.message.year_to_date'), id:10},
    {label:translate('ra.message.month_to_date'), id:11},
    {label:translate('ra.message.week_to_date'), id:12},
    {label:translate('ra.field.custom'), id:13},
  ]
  }), [translate])
  if(id !== null){
    const selectedCategory = data[category] || []
    return selectedCategory.find(item=>item.id === id)?.label
  }
  return data[category] || []
}